import React, { Component } from 'react'
import { Button, Popconfirm } from 'antd'
import ProposalSectionLines from './ProposalSectionLines'
import { DebounceInput } from 'react-debounce-input'

const ButtonGroup = Button.Group

class ProposalSection extends Component {
  renderGroup = (section, sectionIndex) => {
    const {
      handleChangeSectionName,
      handleMoveSectionUp,
      handleMoveSectionDown,
      handleDeleteSection,
      handleDuplicateSection,
      handleAddItem,
      handleDeleteItem,
      handleItemChange,
      moveItemRight,
      moveItemLeft,
      moveItemUp,
      moveItemDown,
      sectionId
    } = this.props
    if (section.markedForDeletion) {
      return null
    }
    return (
      <table className="table table-bordered">
        <thead className="table-primary">
          <tr>
            <th scope="col">
              <DebounceInput
                className="ant-input"
                minLength={0}
                debounceTimeout={500}
                width={300}
                value={section.name}
                onChange={event => {
                  handleChangeSectionName(sectionIndex, event.target.value)
                }}
                name="description"
              />
            </th>
            <th scope="col" className="text-right">
              <ButtonGroup>
                <Button onClick={() => handleDuplicateSection(sectionIndex)}>Duplicate</Button>
                <Button
                  type="normal"
                  onClick={() => handleMoveSectionDown(sectionIndex)}
                  icon="down"
                />
                <Button type="normal" onClick={() => handleMoveSectionUp(sectionIndex)} icon="up" />
                <Popconfirm
                  title="Are you sure you want to delete this group?"
                  onConfirm={() => handleDeleteSection(sectionIndex)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button type="danger" icon="delete" />
                </Popconfirm>
              </ButtonGroup>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan="2">
              <div className="row">
                <div className="col-6">Name</div>
                <div className="col-6 text-right">Actions</div>
              </div>
              <div className="row">
                <div className="col-12">
                  <ProposalSectionLines
                    proposalItems={section.items}
                    sectionId={sectionId}
                    sectionIndex={sectionIndex}
                    handleItemChange={handleItemChange}
                    moveItemRight={moveItemRight}
                    moveItemLeft={moveItemLeft}
                    moveItemUp={moveItemUp}
                    moveItemDown={moveItemDown}
                    handleDeleteItem={handleDeleteItem}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 text-right">
                  <Button icon="plus" onClick={() => handleAddItem(sectionIndex)}>
                    Add New Item
                  </Button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  render() {
    const { section, sectionIndex } = this.props

    return <div>{this.renderGroup(section, sectionIndex)}</div>
  }
}

export default ProposalSection



// WEBPACK FOOTER //
// ./src/components/ProposalSection.js